<ng-container>

  <div class="col-md-4">
    <h1 class="no-margin">

            <span style="color: #43425d; font-weight: 500; font-size: 20px;">Moj kalendar
                <i style="font-size: 12px" class="fas fa-chevron-down"></i></span>
    </h1>
    <p style="color: gray;">Pregled zadataka po datumima</p>
  </div>
  <div class="col-md-8">
    <nav aria-label="breadcrumb text-right">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a routerLink="/home">Početna</a></li>
        <li class="breadcrumb-item"><a routerLink="/timeline">Filtriranje zadataka</a></li>
      </ol>
    </nav>
  </div>


  <button style="visibility: hidden" (click)="updateHeader()" id="updateHeader">Update header</button>
  <button style="visibility: hidden" (click)="getEvents()" id="getEvents">Update events</button>
  <full-calendar #fullcalendar
                 style="padding-left: 20px;
    padding-right: 20px;"
                 [options]="calendarOptions"
                 defaultView="dayGridMonth"

  ></full-calendar>
</ng-container>


